module.exports = __webpack_public_path__ + "img/132.2e010ee3.jpg";